import type { RecommendedDisposition } from "../api/types";
import { solutionTagIdSet } from "./mergeTagIds";

const DISPOSITION_LABEL: Record<RecommendedDisposition, string> = {
  accept: "Accept",
  reject: "Reject",
  skip: "Skip",
};

export function dispositionLabel(
  disposition: RecommendedDisposition | null | undefined
): string | null {
  if (!disposition) return null;
  return DISPOSITION_LABEL[disposition] ?? disposition;
}

/** Format 0..1 confidence as a whole-number percent, or null when unknown. */
export function formatConfidencePercent(
  confidence: number | null | undefined
): string | null {
  if (confidence == null || !Number.isFinite(confidence)) return null;
  const pct = Math.round(Math.min(1, Math.max(0, confidence)) * 100);
  return `${pct}%`;
}

/** Solution tag ids present on the asset from the solution-tags catalog. */
export function solutionTagIdsFromAsset(
  existingIds: number[],
  solutionTags: { id: number; is_solution?: boolean }[]
): number[] {
  const ids = solutionTagIdSet(solutionTags);
  return existingIds.filter((id) => ids.has(id));
}
